import { AppShell } from './AppShell';
import { AppStoreProvider } from './state/AppStoreProvider';
import { SymbolResources } from './shell/style/SymbolResources';

export function App() {
  return (
    <AppStoreProvider>
      <SymbolResources>
        <AppShell />
      </SymbolResources>
    </AppStoreProvider>
  );
}
